import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function AboutSection() {
  const { t } = useTranslation();
  const sectionRef = useScrollAnimation();

  const features = [
    {
      icon: 'ri-timer-flash-line',
      titleKey: 'section_about_desc_1',
      color: 'accent',
    },
    {
      icon: 'ri-line-chart-line',
      titleKey: 'section_about_desc_2',
      color: 'primary',
    },
    {
      icon: 'ri-stack-line',
      titleKey: 'section_about_desc_3',
      color: 'accent',
    },
    {
      icon: 'ri-user-heart-line',
      titleKey: 'section_about_desc_4',
      color: 'primary',
    },
  ];

  return (
    <section ref={sectionRef} className="py-16 md:py-24 bg-secondary-50">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16 animate-on-scroll">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wider uppercase mb-4">
            Kakobuy Spreadsheet
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 font-heading">
            {t('section_about_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="animate-on-scroll group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60 transition-all duration-300 hover:border-accent-200 cursor-default"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-all duration-300 group-hover:scale-110 ${
                feature.color === 'accent'
                  ? 'bg-accent-100 text-accent-600'
                  : 'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {t(feature.titleKey)}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 text-center">
          <div className="animate-on-scroll p-6 rounded-2xl bg-background-50 border border-background-200/60">
            <div className="text-3xl md:text-4xl font-bold text-accent-600 font-heading mb-2">14+</div>
            <p className="text-sm text-foreground-600">Kategorii produktów</p>
          </div>
          <div className="animate-on-scroll p-6 rounded-2xl bg-background-50 border border-background-200/60" style={{ transitionDelay: '100ms' }}>
            <div className="text-3xl md:text-4xl font-bold text-accent-600 font-heading mb-2">1000+</div>
            <p className="text-sm text-foreground-600">Produktów w bazie</p>
          </div>
          <div className="animate-on-scroll p-6 rounded-2xl bg-background-50 border border-background-200/60" style={{ transitionDelay: '200ms' }}>
            <div className="text-3xl md:text-4xl font-bold text-accent-600 font-heading mb-2">24/7</div>
            <p className="text-sm text-foreground-600">Dostępność online</p>
          </div>
          <div className="animate-on-scroll p-6 rounded-2xl bg-background-50 border border-background-200/60" style={{ transitionDelay: '300ms' }}>
            <div className="text-3xl md:text-4xl font-bold text-accent-600 font-heading mb-2">2026</div>
            <p className="text-sm text-foreground-600">Najnowsza aktualizacja</p>
          </div>
        </div>
      </div>
    </section>
  );
}